<template>
    <div>
        <canvas ref="canvas" :height="height" style="object-fit: contain; width: 100%; border:1px solid #000000;"></canvas>
    </div>
</template>


<script>

export default {

    /**
     * Unnecessary overcomplicated fot backwards compatibility
     */

    props: {
        colorStart: {
            type: String,
            default: '#ff0000aa',
        },
        colorStop: {
            type: String,
            default: '#ffff00aa',
        },

        min : {
            type: Number,
            default: 0,
        },

        max : {
            type: Number,
            default: 2,
        },

        treshold : {
            type: Number,
            default: 0.5,
        },

        height: {
            type: Number,
            default: 20,
        },

        dtype: {
            type: String,
            default: 'float',
        },

        operation: {
            type: String,
            required: true,
        },

        font: {
            type: String,
            default: '16px Arial',
        }
    },

    data: () => ({

        transparentColor: '#ffffff00',
        blackColor : '#000000aa'
    }),

    mounted: function(){
        this.colorize();
    },


    methods: {


        // call from refs
        colorize: function()
        {   
            let canvas = this.$refs.canvas;
            let ctx = canvas.getContext('2d');

            ctx.font = this.font;
            ctx.textBaseline = 'middle';

            ctx.clearRect(0,0, canvas.width, canvas.height);

            if(this.operation == 'view')
                this.drawViewOperation(canvas, ctx, this.treshold);
          
            else if(this.operation == 'summarize')
                this.drawSummarizeOperation(canvas, ctx, this.treshold)

            else if(this.operation == 'change')
                this.drawChangeOperation(canvas, ctx, this.treshold);



        },

        drawViewOperation: function(canvas, ctx, treshold) {

            // same as summarize
            return this.drawSummarizeOperation(canvas, ctx, treshold);
        },

        drawSummarizeOperation: function(canvas, ctx, treshold) {

            this._drawGradient(canvas, ctx);

            ctx.fillStyle = "black";

            let startText = String(treshold);
            let endText = this.max;

            ctx.textAlign = "start";
            ctx.fillText(" " + startText, 2, canvas.height/2);

            ctx.textAlign = "end";
            ctx.fillText(endText + " ", canvas.width, canvas.height/2);
        },


        drawChangeOperation: function(canvas, ctx, treshold) {


            let gradient = ctx.createLinearGradient(0, 0, canvas.width, canvas.height);
            gradient.addColorStop(0, this.colorStart);
            gradient.addColorStop(0.50 - treshold, this.blackColor);
            gradient.addColorStop(0.50 - treshold, this.transparentColor);
            gradient.addColorStop(0.50 + treshold, this.transparentColor);
            gradient.addColorStop(0.50 + treshold, this.blackColor);
            gradient.addColorStop(1, this.colorStop);

            ctx.fillStyle = gradient;
            ctx.fillRect(0, 0, canvas.width, canvas.height);

            ctx.fillStyle = "black";

            let startText = this.min
            ctx.textAlign = "start";
            ctx.fillText(" " + startText, 2, canvas.height/2);

            let endText = this.max
            ctx.textAlign = "end";
            ctx.fillText(endText + " ", canvas.width, canvas.height/2);

            let centerText = "< |" + this.treshold + "|";
            ctx.textAlign = "center";
            ctx.fillText(centerText, canvas.width/2, canvas.height/2);

        },

        getRectStart()
        {
            return  this.$refs.canvas.width/(this._max + 1);
        },

        round(val)
        {
            return Math.round( val * 100) / 100;
        },

        _drawGradient(canvas, ctx)
        {
            let gradient = ctx.createLinearGradient(0, 0, canvas.width, canvas.height);
            gradient.addColorStop(0, this.colorStart);
            gradient.addColorStop(1, this.colorStop);

            ctx.fillStyle = gradient;
            ctx.fillRect(0, 0, canvas.width, canvas.height);
        }
    },


    watch: {

        colorStart : function() {
            this.colorize();
        },

        colorStop : function() {
            this.colorize();
        },
    }

};
</script>
